$(function() {
    var swiper = new Swiper('.item-image .swiper-container', {
        slidesPerView: 1,
        spaceBetween: 0,
        watchOverflow:true,
        a11y: {
            enabled: true,
            slideLabelMessage: ""
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true,
            renderBullet: function(index, className) {
                return `
                    <button type="button" class="${className}" aria-label="Go to slide ${index + 1}">${index + 1}</button>
                `
            }
        },
      });
})